import * as z from "zod/v4";

export enum PrintableDocument {
  PICK_LIST = "pickList",
  PACKING_SLIP = "packingSlip",
  LABEL = "label",
  COMMERCIAL_INVOICE = "commercialInvoice",
  PERSONALIZED_SLIP = "personalizedSlip",
  RETURN_LABEL = "returnLabel",
  LOCAL_PICK_UP_LABEL = "localPickUpLabel",
}

export const DocumentTypeSchema = z.enum(PrintableDocument);

export const PrintableDocumentsDisplayName = {
  [PrintableDocument.PICK_LIST]: "Shipping label",
  [PrintableDocument.PACKING_SLIP]: "Packing slip",
  [PrintableDocument.LABEL]: "Shipping label",
  [PrintableDocument.COMMERCIAL_INVOICE]: "Commercial invoice",
  [PrintableDocument.PERSONALIZED_SLIP]: "Personalized slip",
  [PrintableDocument.RETURN_LABEL]: "Return label",
  [PrintableDocument.LOCAL_PICK_UP_LABEL]: "Local pick up label",
};

// TODO: Migrate this to PrintableDocument
export enum PrintKind {
  PICK_LIST = "pickListPrinted",
  PACKING_SLIP = "packingSlipPrinted",
  LABEL = "labelPrinted",
  COMMERCIAL_INVOICE = "commercialInvoicePrinted",
  PERSONALIZED_SLIP = "personalizedSlipPrinted",
  RETURN_LABEL = "returnLabelPrinted",
  LOCAL_PICK_UP_LABEL = "localPickUpLabelPrinted",
}

export const PrintKindForDocument = {
  [PrintableDocument.PICK_LIST]: PrintKind.PICK_LIST,
  [PrintableDocument.PACKING_SLIP]: PrintKind.PACKING_SLIP,
  [PrintableDocument.LABEL]: PrintKind.LABEL,
  [PrintableDocument.COMMERCIAL_INVOICE]: PrintKind.COMMERCIAL_INVOICE,
  [PrintableDocument.PERSONALIZED_SLIP]: PrintKind.PERSONALIZED_SLIP,
  [PrintableDocument.RETURN_LABEL]: PrintKind.RETURN_LABEL,
  [PrintableDocument.LOCAL_PICK_UP_LABEL]: PrintKind.LOCAL_PICK_UP_LABEL,
};

const PrintStatusSchema_ = z.object({
  [PrintKind.PICK_LIST]: z.boolean().nullish(),
  [PrintKind.PACKING_SLIP]: z.boolean().nullish(),
  [PrintKind.LABEL]: z.boolean().nullish(),
  [PrintKind.COMMERCIAL_INVOICE]: z.boolean().nullish(),
  [PrintKind.PERSONALIZED_SLIP]: z.boolean().nullish(),
  [PrintKind.RETURN_LABEL]: z.boolean().nullish(),
  [PrintKind.LOCAL_PICK_UP_LABEL]: z.boolean().nullish(),
  packingSlipPrintedAt: z.date().nullish(),
});

export const PrintStatusSchema: z.ZodType<PrintStatus> = PrintStatusSchema_;

export interface PrintStatus extends z.infer<typeof PrintStatusSchema_> {}
